module.exports = __webpack_public_path__ + "static/media/unlink.20fe16ee.png";